const theme = {
  screens: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1600px",
  },
  spacing: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  colors: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  fontFamily: { sans: ["Poppins", "sans-serif"] },
  fontSize: {
    xs: "12px",
    sm: "14px",
    base: "16px",
    lg: "18px",
    xl: "22px",
    "2xl": "24px",
    "3xl": "28px",
    "4xl": [
      "2.125rem",
      { lineHeight: "51px", letterSpacing: "-0.02em", fontWeight: "600" },
    ],
    "5xl": "40px",
    "6xl": "60px",
  },
  fontWeight: { normal: "400", medium: "500", semibold: "600", bold: "700" },
  lineHeight: {
    3: ".75rem",
    9: "2.25rem",
    none: 1,
    small: 1.17,
    tight: 1.2,
    normal: "1.5",
    relaxed: "26px",
    "extra-loose": "51px",
  },
  supports: {},
  columns: {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    10: "10",
    11: "11",
    12: "12",
    auto: "auto",
    "3xs": "16rem",
    "2xs": "18rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
  },
  animation: {
    none: "none",
    spin: "spin 1s linear infinite",
    ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    bounce: "bounce 1s infinite",
    dots: "dots 1s steps(5, end) infinite",
    "dropdown-menu-open": "dropdown .4s cubic-bezier(.73,.005,.22,1)",
  },
  aria: {
    checked: 'checked="true"',
    disabled: 'disabled="true"',
    expanded: 'expanded="true"',
    hidden: 'hidden="true"',
    pressed: 'pressed="true"',
    readonly: 'readonly="true"',
    required: 'required="true"',
    selected: 'selected="true"',
  },
  aspectRatio: { auto: "auto", square: "1 / 1", video: "16 / 9" },
  backdropBlur: {
    0: "0",
    none: "0",
    sm: "4px",
    DEFAULT: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px",
  },
  backdropBrightness: {
    0: "0",
    50: ".5",
    75: ".75",
    90: ".9",
    95: ".95",
    100: "1",
    105: "1.05",
    110: "1.1",
    125: "1.25",
    150: "1.5",
    200: "2",
  },
  backdropContrast: {
    0: "0",
    50: ".5",
    75: ".75",
    100: "1",
    125: "1.25",
    150: "1.5",
    200: "2",
  },
  backdropGrayscale: { 0: "0", DEFAULT: "100%" },
  backdropHueRotate: {
    0: "0deg",
    15: "15deg",
    30: "30deg",
    60: "60deg",
    90: "90deg",
    180: "180deg",
  },
  backdropInvert: { 0: "0", DEFAULT: "100%" },
  backdropOpacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
  },
  backdropSaturate: { 0: "0", 50: ".5", 100: "1", 150: "1.5", 200: "2" },
  backdropSepia: { 0: "0", DEFAULT: "100%" },
  backgroundColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  backgroundImage: {
    none: "none",
    "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
    "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
    "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
    "gradient-to-br":
      "linear-gradient(to bottom right, var(--tw-gradient-stops))",
    "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
    "gradient-to-bl":
      "linear-gradient(to bottom left, var(--tw-gradient-stops))",
    "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
    "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))",
  },
  backgroundOpacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
  },
  backgroundPosition: {
    bottom: "bottom",
    center: "center",
    left: "left",
    "left-bottom": "left bottom",
    "left-top": "left top",
    right: "right",
    "right-bottom": "right bottom",
    "right-top": "right top",
    top: "top",
  },
  backgroundSize: { auto: "auto", cover: "cover", contain: "contain" },
  blur: {
    0: "0",
    none: "0",
    sm: "4px",
    DEFAULT: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px",
  },
  brightness: {
    0: "0",
    50: ".5",
    75: ".75",
    90: ".9",
    95: ".95",
    100: "1",
    105: "1.05",
    110: "1.1",
    125: "1.25",
    150: "1.5",
    200: "2",
  },
  borderColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
    DEFAULT: "currentColor",
  },
  borderOpacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
  },
  borderRadius: {
    none: "0px",
    sm: "0.125rem",
    DEFAULT: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px",
  },
  borderSpacing: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  borderWidth: { 0: "0px", 2: "2px", 4: "4px", 8: "8px", DEFAULT: "1px" },
  boxShadow: {
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    none: "none",
    trube: "0 4px 20px rgba(0, 0, 0, 0.1)",
  },
  boxShadowColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  caretColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  accentColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
    auto: "auto",
  },
  contrast: {
    0: "0",
    50: ".5",
    75: ".75",
    100: "1",
    125: "1.25",
    150: "1.5",
    200: "2",
  },
  container: {},
  content: { none: "none" },
  cursor: {
    auto: "auto",
    default: "default",
    pointer: "pointer",
    wait: "wait",
    text: "text",
    move: "move",
    help: "help",
    "not-allowed": "not-allowed",
    none: "none",
    "context-menu": "context-menu",
    progress: "progress",
    cell: "cell",
    crosshair: "crosshair",
    "vertical-text": "vertical-text",
    alias: "alias",
    copy: "copy",
    "no-drop": "no-drop",
    grab: "grab",
    grabbing: "grabbing",
    "all-scroll": "all-scroll",
    "col-resize": "col-resize",
    "row-resize": "row-resize",
    "n-resize": "n-resize",
    "e-resize": "e-resize",
    "s-resize": "s-resize",
    "w-resize": "w-resize",
    "ne-resize": "ne-resize",
    "nw-resize": "nw-resize",
    "se-resize": "se-resize",
    "sw-resize": "sw-resize",
    "ew-resize": "ew-resize",
    "ns-resize": "ns-resize",
    "nesw-resize": "nesw-resize",
    "nwse-resize": "nwse-resize",
    "zoom-in": "zoom-in",
    "zoom-out": "zoom-out",
    disabled: "not-allowed",
  },
  divideColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
    DEFAULT: "currentColor",
  },
  divideOpacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
  },
  divideWidth: { 0: "0px", 2: "2px", 4: "4px", 8: "8px", DEFAULT: "1px" },
  dropShadow: {
    sm: "0 1px 1px rgb(0 0 0 / 0.05)",
    DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
    md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
    lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
    xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
    "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
    none: "0 0 #0000",
    trube: "0 4px 20px rgba(0, 0, 0, 0.1)",
  },
  fill: {
    none: "none",
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  grayscale: { 0: "0", DEFAULT: "100%" },
  hueRotate: {
    0: "0deg",
    15: "15deg",
    30: "30deg",
    60: "60deg",
    90: "90deg",
    180: "180deg",
  },
  invert: { 0: "0", DEFAULT: "100%" },
  flex: { 1: "1 1 0%", auto: "1 1 auto", initial: "0 1 auto", none: "none" },
  flexBasis: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    auto: "auto",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
    "1/2": "50%",
    "1/3": "33.333333%",
    "2/3": "66.666667%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
    "1/5": "20%",
    "2/5": "40%",
    "3/5": "60%",
    "4/5": "80%",
    "1/6": "16.666667%",
    "2/6": "33.333333%",
    "3/6": "50%",
    "4/6": "66.666667%",
    "5/6": "83.333333%",
    "1/12": "8.333333%",
    "2/12": "16.666667%",
    "3/12": "25%",
    "4/12": "33.333333%",
    "5/12": "41.666667%",
    "6/12": "50%",
    "7/12": "58.333333%",
    "8/12": "66.666667%",
    "9/12": "75%",
    "10/12": "83.333333%",
    "11/12": "91.666667%",
  },
  flexGrow: { 0: "0", DEFAULT: "1" },
  flexShrink: { 0: "0", DEFAULT: "1" },
  gap: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  gradientColorStops: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  gridAutoColumns: {
    auto: "auto",
    min: "min-content",
    max: "max-content",
    fr: "minmax(0, 1fr)",
  },
  gridAutoRows: {
    auto: "auto",
    min: "min-content",
    max: "max-content",
    fr: "minmax(0, 1fr)",
  },
  gridColumn: {
    auto: "auto",
    "span-1": "span 1 / span 1",
    "span-2": "span 2 / span 2",
    "span-3": "span 3 / span 3",
    "span-4": "span 4 / span 4",
    "span-5": "span 5 / span 5",
    "span-6": "span 6 / span 6",
    "span-7": "span 7 / span 7",
    "span-8": "span 8 / span 8",
    "span-9": "span 9 / span 9",
    "span-10": "span 10 / span 10",
    "span-11": "span 11 / span 11",
    "span-12": "span 12 / span 12",
    "span-full": "1 / -1",
  },
  gridColumnEnd: {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    10: "10",
    11: "11",
    12: "12",
    13: "13",
    auto: "auto",
  },
  gridColumnStart: {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    10: "10",
    11: "11",
    12: "12",
    13: "13",
    auto: "auto",
  },
  gridRow: {
    auto: "auto",
    "span-1": "span 1 / span 1",
    "span-2": "span 2 / span 2",
    "span-3": "span 3 / span 3",
    "span-4": "span 4 / span 4",
    "span-5": "span 5 / span 5",
    "span-6": "span 6 / span 6",
    "span-full": "1 / -1",
  },
  gridRowStart: {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    auto: "auto",
  },
  gridRowEnd: {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    auto: "auto",
  },
  gridTemplateColumns: {
    1: "repeat(1, minmax(0, 1fr))",
    2: "repeat(2, minmax(0, 1fr))",
    3: "repeat(3, minmax(0, 1fr))",
    4: "repeat(4, minmax(0, 1fr))",
    5: "repeat(5, minmax(0, 1fr))",
    6: "repeat(6, minmax(0, 1fr))",
    7: "repeat(7, minmax(0, 1fr))",
    8: "repeat(8, minmax(0, 1fr))",
    9: "repeat(9, minmax(0, 1fr))",
    10: "repeat(10, minmax(0, 1fr))",
    11: "repeat(11, minmax(0, 1fr))",
    12: "repeat(12, minmax(0, 1fr))",
    none: "none",
    "available-partners": "repeat(auto-fit, minmax(576px, 1fr))",
    account: "176px auto",
    "account-cards": "repeat(auto-fit, minmax(480px, 1fr))",
    "account-two-cols-layout": "auto 320px",
  },
  gridTemplateRows: {
    1: "repeat(1, minmax(0, 1fr))",
    2: "repeat(2, minmax(0, 1fr))",
    3: "repeat(3, minmax(0, 1fr))",
    4: "repeat(4, minmax(0, 1fr))",
    5: "repeat(5, minmax(0, 1fr))",
    6: "repeat(6, minmax(0, 1fr))",
    none: "none",
  },
  height: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    auto: "auto",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
    "1/2": "50%",
    "1/3": "33.333333%",
    "2/3": "66.666667%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
    "1/5": "20%",
    "2/5": "40%",
    "3/5": "60%",
    "4/5": "80%",
    "1/6": "16.666667%",
    "2/6": "33.333333%",
    "3/6": "50%",
    "4/6": "66.666667%",
    "5/6": "83.333333%",
    screen: "100vh",
    min: "min-content",
    max: "max-content",
    fit: "fit-content",
  },
  inset: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    auto: "auto",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
    "1/2": "50%",
    "1/3": "33.333333%",
    "2/3": "66.666667%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
  },
  keyframes: {
    spin: { to: { transform: "rotate(360deg)" } },
    ping: { "75%, 100%": { transform: "scale(2)", opacity: "0" } },
    pulse: { "50%": { opacity: ".5" } },
    bounce: {
      "0%, 100%": {
        transform: "translateY(-25%)",
        animationTimingFunction: "cubic-bezier(0.8,0,1,1)",
      },
      "50%": {
        transform: "none",
        animationTimingFunction: "cubic-bezier(0,0,0.2,1)",
      },
    },
    dots: {
      "0%, 20%": {
        color: "rgba(255,255,255,0)",
        "text-shadow": ".25em 0 0 #FFFFFF, .5em 0 0 #FFFFFF",
      },
      "40%": {
        color: "black",
        "text-shadow": ".25em 0 0 #FFFFFF, .5em 0 0 #FFFFFF",
      },
      "60%": { "text-shadow": ".25em 0 0 #203B54, .5em 0 0 #FFFFFF" },
      "80%, 100%": { "text-shadow": ".25em 0 0 #203B54, .5em 0 0 #203B54" },
    },
    dropdown: {
      "0%": { opacity: 0, transform: "scale(.98) translateY(-.6em)" },
      "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
    },
  },
  letterSpacing: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0em",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
  },
  listStyleType: { none: "none", disc: "disc", decimal: "decimal" },
  margin: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    auto: "auto",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  maxHeight: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
    screen: "100vh",
    min: "min-content",
    max: "max-content",
    fit: "fit-content",
  },
  maxWidth: {
    0: "0rem",
    none: "none",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    full: "100%",
    min: "min-content",
    max: "max-content",
    fit: "fit-content",
    prose: "65ch",
    "screen-sm": "640px",
    "screen-md": "768px",
    "screen-lg": "1024px",
    "screen-xl": "1280px",
    "screen-2xl": "1600px",
  },
  minHeight: {
    0: "0px",
    full: "100%",
    screen: "100vh",
    min: "min-content",
    max: "max-content",
    fit: "fit-content",
  },
  minWidth: {
    0: "0px",
    full: "100%",
    min: "min-content",
    max: "max-content",
    fit: "fit-content",
  },
  objectPosition: {
    bottom: "bottom",
    center: "center",
    left: "left",
    "left-bottom": "left bottom",
    "left-top": "left top",
    right: "right",
    "right-bottom": "right bottom",
    "right-top": "right top",
    top: "top",
  },
  opacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
  },
  order: {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    10: "10",
    11: "11",
    12: "12",
    first: "-9999",
    last: "9999",
    none: "0",
  },
  padding: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  placeholderColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  placeholderOpacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
  },
  outlineColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  outlineOffset: { 0: "0px", 1: "1px", 2: "2px", 4: "4px", 8: "8px" },
  outlineWidth: { 0: "0px", 1: "1px", 2: "2px", 4: "4px", 8: "8px" },
  ringColor: {
    DEFAULT: "#3b82f6",
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  ringOffsetColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  ringOffsetWidth: { 0: "0px", 1: "1px", 2: "2px", 4: "4px", 8: "8px" },
  ringOpacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
    DEFAULT: "0.5",
  },
  ringWidth: {
    0: "0px",
    1: "1px",
    2: "2px",
    4: "4px",
    8: "8px",
    DEFAULT: "3px",
  },
  rotate: {
    0: "0deg",
    1: "1deg",
    2: "2deg",
    3: "3deg",
    6: "6deg",
    12: "12deg",
    45: "45deg",
    90: "90deg",
    180: "180deg",
  },
  saturate: { 0: "0", 50: ".5", 100: "1", 150: "1.5", 200: "2" },
  scale: {
    0: "0",
    50: ".5",
    75: ".75",
    90: ".9",
    95: ".95",
    100: "1",
    105: "1.05",
    110: "1.1",
    125: "1.25",
    150: "1.5",
  },
  scrollMargin: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  scrollPadding: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  sepia: { 0: "0", DEFAULT: "100%" },
  skew: { 0: "0deg", 1: "1deg", 2: "2deg", 3: "3deg", 6: "6deg", 12: "12deg" },
  space: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  stroke: {
    none: "none",
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  strokeWidth: { 0: "0", 1: "1", 2: "2" },
  textColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  textDecorationColor: {
    transparent: "transparent",
    current: "currentColor",
    "basic-trueblack": "#000000",
    "black-grey": "#111418",
    "blue-dark": "#203B54",
    "grey-main": "#303740",
    grey: "#6B7178",
    "blue-grey": "#72879A",
    "grey-inactive": "#CBCFD5",
    "blue-grey-light": "#E0EAF3",
    "grey-light": "#F8F8F8",
    "basic-white": "#FFFFFF",
    coral: "#FF7557",
    "coral-light": "#FF947C",
    blue: "#3AA1FF",
    "blue-light": "#83C3FF",
    green: "#3BC693",
    "green-light": "#61D2A8",
    "bg-green": "#3BC693",
    "bg-green-light": "#61D2A8",
    cream: "#F4EDE6",
  },
  textDecorationThickness: {
    0: "0px",
    1: "1px",
    2: "2px",
    4: "4px",
    8: "8px",
    auto: "auto",
    "from-font": "from-font",
  },
  textUnderlineOffset: {
    0: "0px",
    1: "1px",
    2: "2px",
    4: "4px",
    8: "8px",
    auto: "auto",
  },
  textIndent: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
  },
  textOpacity: {
    0: "0",
    5: "0.05",
    10: "0.1",
    20: "0.2",
    25: "0.25",
    30: "0.3",
    40: "0.4",
    50: "0.5",
    60: "0.6",
    70: "0.7",
    75: "0.75",
    80: "0.8",
    90: "0.9",
    95: "0.95",
    100: "1",
  },
  transformOrigin: {
    center: "center",
    top: "top",
    "top-right": "top right",
    right: "right",
    "bottom-right": "bottom right",
    bottom: "bottom",
    "bottom-left": "bottom left",
    left: "left",
    "top-left": "top left",
  },
  transitionDelay: {
    75: "75ms",
    100: "100ms",
    150: "150ms",
    200: "200ms",
    300: "300ms",
    500: "500ms",
    700: "700ms",
    1000: "1000ms",
  },
  transitionDuration: {
    75: "75ms",
    100: "100ms",
    150: "150ms",
    200: "200ms",
    300: "300ms",
    500: "500ms",
    700: "700ms",
    1000: "1000ms",
    DEFAULT: "150ms",
  },
  transitionProperty: {
    none: "none",
    all: "all",
    DEFAULT:
      "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    colors:
      "color, background-color, border-color, text-decoration-color, fill, stroke",
    opacity: "opacity",
    shadow: "box-shadow",
    transform: "transform",
  },
  transitionTimingFunction: {
    DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
    linear: "linear",
    in: "cubic-bezier(0.4, 0, 1, 1)",
    out: "cubic-bezier(0, 0, 0.2, 1)",
    "in-out": "cubic-bezier(0.4, 0, 0.2, 1)",
  },
  translate: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
    "1/2": "50%",
    "1/3": "33.333333%",
    "2/3": "66.666667%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
  },
  width: {
    0: "0",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "56px",
    7: "64px",
    8: "80px",
    24: "6rem",
    28: "7rem",
    29: "7.25rem",
    32: "8rem",
    40: "10rem",
    44: "176px",
    48: "192px",
    52: "13rem",
    80: "20rem",
    94: "376px",
    120: "30rem",
    auto: "auto",
    0.5: "0.25rem",
    1.5: "12px",
    full: "100%",
    "1/2": "50%",
    "1/3": "33.333333%",
    "2/3": "66.666667%",
    "1/4": "25%",
    "2/4": "50%",
    "3/4": "75%",
    "1/5": "20%",
    "2/5": "40%",
    "3/5": "60%",
    "4/5": "80%",
    "1/6": "16.666667%",
    "2/6": "33.333333%",
    "3/6": "50%",
    "4/6": "66.666667%",
    "5/6": "83.333333%",
    "1/12": "8.333333%",
    "2/12": "16.666667%",
    "3/12": "25%",
    "4/12": "33.333333%",
    "5/12": "41.666667%",
    "6/12": "50%",
    "7/12": "58.333333%",
    "8/12": "66.666667%",
    "9/12": "75%",
    "10/12": "83.333333%",
    "11/12": "91.666667%",
    screen: "100vw",
    min: "min-content",
    max: "max-content",
    fit: "fit-content",
  },
  willChange: {
    auto: "auto",
    scroll: "scroll-position",
    contents: "contents",
    transform: "transform",
  },
  zIndex: {
    0: "0",
    1: "1",
    10: "10",
    20: "20",
    30: "30",
    40: "40",
    50: "50",
    995: "995",
    1005: "1005",
    auto: "auto",
  },
};

export default theme;
